import { render, staticRenderFns } from "./PropertyDetailsTable.vue?vue&type=template&id=326ce100&"
import script from "./PropertyDetailsTable.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports